// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"icon_ko-KR___I1L8","impressionTrackingContainer":"icon_impressionTrackingContainer__r4SD_","vc-icon":"icon_vc-icon__qDVyL","spin":"icon_spin__SuyCK"};